export const formatCost = (cost) => `$${Number(cost ?? 0).toFixed(4)}`;

export const formatCount = (count) => Number(count ?? 0).toLocaleString();
